import { createSlice } from '@reduxjs/toolkit';
import { toggleArrayByObject } from '../../Utils/general';
import { MONTH_VALIDITY, SIMULANIS_INDIA, TRIAL_PACK } from '../../Constant/constant';

const initialState = {
    checkedApplication: [],
    checkedResource: [],
    dateRange: [null, null],
    validityType: MONTH_VALIDITY,
    validityKey: null,
    amount: "",
    invoice: "",
    planType: TRIAL_PACK,
    entityType: SIMULANIS_INDIA,
    reminder: null,
    newsletter: null,
    saleType: null,
    useCaseTgs: []
};

const subscriptionSlice = createSlice({
    name: 'checkbox',
    initialState,
    reducers: {
        resetSubscription:()=>({...initialState}),
        setUpdateApplication: (state, action) => {
            state.checkedApplication = action.payload.data;
        },
        setUpdateResource: (state, action) => {
            state.checkedResource = action.payload.data;
        },
        setToggleApplication: (state, action) => {
            state.checkedApplication = toggleArrayByObject(state.checkedApplication, { ...action.payload.data, dates: state.dateRange });
        },
        setToggleResource: (state, action) => {
            state.checkedResource = toggleArrayByObject(state.checkedResource, { ...action.payload.data, dates: state.dateRange });
        },
        setdateRange: (state, action) => {
            state.dateRange = action.payload.data;
        },
        setValidityData: (state, action) => {
            state.dateRange = action.payload.dateRange;
            state.validityType = action.payload.type;
            state.validityKey = action.payload.key;

            let applications = JSON.parse(JSON.stringify(state.checkedApplication));
            state.checkedApplication = applications.map((item) => ({
                ...item,
                dates: action.payload.dateRange
            }));

            let resource = JSON.parse(JSON.stringify(state.checkedResource));
            state.checkedResource = resource.map((item) => ({
                ...item,
                dates: action.payload.dateRange
            }));

        },
        setAmount: (state, action) => {
            state.amount = action.payload.data;
        },
        setInvoice: (state, action) => {
            state.invoice = action.payload.data;
        },
        setReminder: (state, action) => {
            state.reminder = action.payload.data;
        },
        setPlanType: (state, action) => {
            state.planType = action.payload.data;
        },
        setNewsletter: (state, action) => {
            state.newsletter = action.payload.data;
        },
        setEntityType: (state, action) => {
            state.entityType = action.payload.data;
        },
        setSaleType: (state, action) => {
            state.saleType = action.payload.data;
        },
        setUseCaseTgs: (state, action) => {
            state.useCaseTgs = action.payload.data;
        },
    },
});

export const { setToggleResource, setUpdateApplication, setUpdateResource, 
      setToggleApplication, setdateRange, setValidityData, 
      setAmount, setInvoice, setReminder, setPlanType, 
      setNewsletter, setSaleType, setEntityType, setUseCaseTgs, 
      resetSubscription } = subscriptionSlice.actions;

export default subscriptionSlice.reducer;
